import Vue from 'vue'
export const EventBus = new Vue()

EventBus.$notifications = Vue.observable({
  unreaded: 0,
  messages: 0,
  connections: 0,
});

EventBus.$currentAuthenticatedPageComponent = Vue.observable({
  index: 0,
})